module.exports = __webpack_public_path__ + "img/01.781bcfa9.png";